import { configureStore } from "@reduxjs/toolkit";
import { commentsApi } from "../api/comments";
import { goalsApi } from "../api/goals";
import { journalEntryApi } from "../api/journal";
import { linksApi } from "../api/links";
import { mcpApi } from "../api/mcp";
import { paymentsApi } from "../api/payments";
import { personalityTestApi } from "../api/personalityTest";
import { reviewApi } from "../api/review";
import { themesApi } from "../api/theme";
import { userApi } from "../api/user";
import { virtualBuddiesApi } from "../api/virtualBuddies";
import goalAchievedReducer from "../features/goalAchieved";
import snackbarReducer from "../features/snackbar";
import { setupListeners } from "@reduxjs/toolkit/query";

export const store = configureStore({
  reducer: {
    [commentsApi.reducerPath]: commentsApi.reducer,
    [goalsApi.reducerPath]: goalsApi.reducer,
    [journalEntryApi.reducerPath]: journalEntryApi.reducer,
    [linksApi.reducerPath]: linksApi.reducer,
    [mcpApi.reducerPath]: mcpApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [personalityTestApi.reducerPath]: personalityTestApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer,
    [themesApi.reducerPath]: themesApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [virtualBuddiesApi.reducerPath]: virtualBuddiesApi.reducer,
    goalAchieved: goalAchievedReducer,
    snackbar: snackbarReducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(commentsApi.middleware)
      .concat(goalsApi.middleware)
      .concat(journalEntryApi.middleware)
      .concat(linksApi.middleware)
      .concat(mcpApi.middleware)
      .concat(paymentsApi.middleware)
      .concat(personalityTestApi.middleware)
      .concat(reviewApi.middleware)
      .concat(themesApi.middleware)
      .concat(userApi.middleware)
      .concat(virtualBuddiesApi.middleware);
  },
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
